import React from "react";
import { formatPrice } from "theme/components/atoms/Typography/Price";
import { defineMessages, injectIntl } from "react-intl";
import FormItem from "theme/components/molecules/Form/Item";
import Checkbox from "theme/components/atoms/Form/Input/Checkbox";

const messages = defineMessages({
  checkboxValueLabel: {
    id: "components.organisms.Configurator.BundleOption.checkboxValueLabel",
    defaultMessage: "{quantity} × {label} (+{price})",
  },
});

const BundleOptionCheckbox = ({ intl, option, selectedValues }) => {
  return (
    <div className="bundle-option">
      <div className="bundle-option__option">
        <FormItem
          label={option.label}
          name={`${option.id}.values`}
          required={option.required}
        >
          {option.values
            .filter((value) => value?.prices)
            .map((value, index) => {
              return (
                <div key={value.value}>
                  <Checkbox
                    appearance="start"
                    label={intl.formatMessage(messages.checkboxValueLabel, {
                      quantity: value.defaultQuantity,
                      label: value.label,
                      price: formatPrice(
                        intl,
                        value.prices.finalPrice.priceInclTax
                      ),
                    })}
                    id={`${option.id}.values[${index}]`}
                    name={`${option.id}.values[${index}]`}
                    checkedValue={value.value}
                    checked={
                      selectedValues?.some(
                        (selected) => selected === value.value
                      ) || false
                    }
                  />
                </div>
              );
            })}
        </FormItem>
      </div>
    </div>
  );
};
export default injectIntl(BundleOptionCheckbox);
